// Shared admin design tokens (light sidebar, orange accent)

export const ADMIN_COLORS = {
  accent: "#F26B1D",
  accentDark: "#D95A10",
  accentSoft: "#FDEBD6",
  accentHover: "#FFF5EB",
  sidebarBg: "#ffffff",
  navText: "#374151",
  navIcon: "#4B5563",
  pageBg: "#EEEEF0",
  surface: "#ffffff",
  surfaceMuted: "#F9FAFB",
  border: "#E5E7EB",
  borderLight: "#F3F4F6",
  textPrimary: "#111827",
  textSecondary: "#6B7280",
  textMuted: "#9CA3AF",
  danger: "#E53945",
};

export const adminSectionHeaderProps = {
  style: {
    background: ADMIN_COLORS.surface,
    color: ADMIN_COLORS.textPrimary,
    padding: "12px 16px",
    borderBottom: `1px solid ${ADMIN_COLORS.border}`,
    borderLeft: `3px solid ${ADMIN_COLORS.accent}`,
  },
  titleTypographyProps: {
    style: {
      fontSize: "0.95rem",
      fontWeight: 700,
      color: ADMIN_COLORS.textPrimary,
    },
  },
  subheaderTypographyProps: {
    style: {
      fontSize: "0.72rem",
      color: ADMIN_COLORS.textSecondary,
    },
  },
};

export const adminCardStyle = {
  borderRadius: 12,
  border: `1px solid ${ADMIN_COLORS.border}`,
  boxShadow: "none",
  overflow: "hidden",
};
